import APICall from "../utils/APICall"

export default class PosServices{
    static listPos = async (page, pageLimit, search,from,to,posStatus ) => {
        return await APICall(`/api/PosRequest/admin/list-pos-request?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}&posStatus=${posStatus }`, "GET")
    }
    static  actionPos = async (payload) => {
        return await APICall("/api/PosRequest/admin/action-pos-request","POST", payload)
    }
    static exportPOS = async (search,from,to,posStatus) => {
        return await APICall (`/api/PosRequest/admin/export-pos-request?search=${search}&from=${from}&to=${to}&posStatus=${posStatus}`, "GET")
    }
    static posSummary = async () => {
        return await APICall("/api/PosRequest/admin/pos-request-summary", "GET");
    }
}